import settings from '@/store/modules/adminPanel/settings'

export default {
  namespaced: true,
  modules: {
    settings
  }
}
